// services/childcare/reportIssue.js
import { api, uploadApi } from "./utils";

// Get all report issues
export const getReportIssues = async (params = {}) => {
  const response = await api.get("/childcare/report-issues", { params });
  return response;
};

// Get report issue by ID
export const getReportIssueById = async (id) => {
  const response = await api.get(`/childcare/report-issues/${id}`);
  return response;
};

// Create report issue
export const createReportIssue = async (data) => {
  const response = await api.post("/childcare/report-issues", data);
  return response;
};

// Update report issue
export const updateReportIssue = async (id, data) => {
  const response = await api.put(`/childcare/report-issues/${id}`, data);
  return response;
};

// Delete report issue
export const deleteReportIssue = async (id) => {
  const response = await api.delete(`/childcare/report-issues/${id}`);
  return response;
};

// Resolve report issue
export const resolveReportIssue = async (id, data) => {
  const response = await api.post(
    `/childcare/report-issues/${id}/resolve`,
    data,
  );
  return response;
};

// Upload attachments
export const uploadReportAttachments = async (reportId, formData) => {
  const response = await uploadApi.post(
    `/childcare/report-issues/${reportId}/attachments`,
    formData,
  );
  return response;
};

// ==================== FACILITY REPORT ISSUES ====================

// Get all report issues for facility
export const getFacilityReportIssues = async (params = {}) => {
  const response = await api.get("/childcare/facility/report-issues", {
    params,
  });
  return response;
};

// Get report issue by ID for facility
export const getFacilityReportIssueById = async (id) => {
  const response = await api.get(`/childcare/facility/report-issues/${id}`);
  return response;
};

// Update report issue from facility
export const updateFacilityReportIssue = async (id, data) => {
  const response = await api.put(
    `/childcare/facility/report-issues/${id}`,
    data,
  );
  return response;
};

// Resolve report issue from facility
export const resolveFacilityReportIssue = async (id, data) => {
  const response = await api.post(
    `/childcare/facility/report-issues/${id}/resolve`,
    data,
  );
  return response;
};

// Send admin reply (triggers email to reporter)
export const addAdminReply = async (id, message) => {
  const response = await api.post(`/childcare/report-issues/${id}/reply`, { message });
  return response;
};
